import { Routes, Route } from '@angular/router';
import { userCleanup } from '@app/store/user';
import { ShellPanelComponent } from '../components/shell/shell.component';

export class ShellPanel {
    static childRoutes(routes: Routes): Route {
        return {
            path: '',
            canDeactivate: [userCleanup()],
            component: ShellPanelComponent,
            children: routes,
        };
    }
}
